export const APPLE_PAY = 'ApplePay'

export const GOOGLE_PAY = 'GooglePay'

export const CRYPTO_PAY = 'Crypto'
